import { useFigureCompositionStore } from '@/store/figure-composition';
import { Button } from '@/components/ui/button';
import { Plus, Trash2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export function PanelControls() {
  const currentComposition = useFigureCompositionStore((state) => state.currentComposition);
  const addPanel = useFigureCompositionStore((state) => state.addPanel);
  const removePanel = useFigureCompositionStore((state) => state.removePanel);

  if (!currentComposition) {
    return null;
  }

  const MAX_PANELS = 6;
  const isAtMaxPanels = currentComposition.panels.length >= MAX_PANELS;

  const handleAddPanel = () => {
    if (isAtMaxPanels) return;
    addPanel({
      plotId: '',
      x: 0,
      y: 0,
      w: 4,
      h: 4,
    });
  };

  return (
    <div className="mb-4">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-medium">Panels ({currentComposition.panels.length}/{MAX_PANELS})</h3>
        <Button 
          onClick={handleAddPanel} 
          size="sm" 
          variant="outline"
          disabled={isAtMaxPanels}
          title={isAtMaxPanels ? `Maximum ${MAX_PANELS} panels reached` : 'Add a new panel'}
        >
          <Plus className="h-4 w-4 mr-1" />
          Add Panel
        </Button>
      </div>
      <div className="space-y-2">
        {currentComposition.panels.length === 0 && (
          <div className="text-sm text-muted-foreground py-2">
            No panels yet. Add a panel or select a template preset.
          </div>
        )}
        {currentComposition.panels.map((panel) => (
          <Card key={panel.id} className="p-2">
            <div className="flex items-center justify-between">
              <div className="flex-1">
                <div className="text-sm font-medium">{panel.label}</div>
                <div className="text-xs text-muted-foreground">
                  {panel.plotId ? 'Plot assigned' : 'No plot assigned'}
                </div>
              </div>
              <Button
                variant="ghost"
                size="sm"
                className="h-8 w-8 p-0 text-destructive hover:text-destructive"
                onClick={() => removePanel(panel.id)}
              >
                <Trash2 className="h-4 w-4" />
              </Button>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}

